/**
 * Opengater events hooks (users service, `admin: events`). CRUD list of promo
 * events. The list endpoint paginates (limit/offset); events are few, so we
 * pull a generous page and surface `total` for a "showing first N" note.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiOg } from './client';
const PATH = '/api/v1/admin/events';
const KEY = ['og', 'events'];
const PAGE = 200;
export function useOgEvents() {
    return useQuery({
        queryKey: KEY,
        queryFn: () => apiOg('users', `${PATH}?limit=${PAGE}&offset=0`),
    });
}
export function useCreateOgEvent() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (body) => apiOg('users', PATH, { method: 'POST', body }),
        onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
    });
}
export function useUpdateOgEvent() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, patch }) => apiOg('users', `${PATH}/${id}`, { method: 'PUT', body: patch }),
        onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
    });
}
export function useDeleteOgEvent() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => apiOg('users', `${PATH}/${id}`, { method: 'DELETE' }),
        onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
    });
}
